import { WarningDialog } from '@strata/react-dialog';
import { dialogStrings } from '@strata/strata-ui-strings';
import { type ComponentProps } from 'react';

type UnsavedChangesDialogProps = Pick<
    ComponentProps<typeof WarningDialog>,
    'isOpen' | 'onPrimaryButtonClick' | 'onSecondaryButtonClick'
>;

export const UnsavedChangesDialog = ({
    isOpen,
    onPrimaryButtonClick,
    onSecondaryButtonClick,
}: UnsavedChangesDialogProps) => (
    <WarningDialog
        dialogTitle={dialogStrings.unsavedChanges.title}
        primaryButtonLabel="Continue"
        secondaryButtonLabel="Return To Form"
        isOpen={isOpen}
        onPrimaryButtonClick={onPrimaryButtonClick}
        onSecondaryButtonClick={onSecondaryButtonClick}
        dialogContent={<p>{dialogStrings.unsavedChanges.body}</p>}
    />
);
